import styled from 'styled-components';
import { Card } from 'antd';

export const PageContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 24px;
`;

export const StyledCard = styled(Card)`
  margin-bottom: 24px;
  box-shadow: 
    0 1px 3px rgba(0, 0, 0, 0.06),
    0 2px 6px rgba(0, 0, 0, 0.04);
  border-radius: 16px;
  border: 1px solid #e8e8e8;
`;

